import React, { useState } from 'react';
import { useApi } from 'model/Api';
import { generalStyle } from 'helper/Style';
import { useScroll } from 'helper/Anchor';
import Layout from 'component/part/Layout';
import BackLink from 'component/part/BackLink';
import FormContent from 'component/part/FormContent';
import Modal, { modalStyle } from 'component/part/Modal';
import ErrorMessage from 'component/part/ErrorMessage';
import H2 from 'component/part/H2';

const style = {
  form: {
    ...generalStyle.form,
    ['& input']: {
      maxWidth: '32rem',
    },
  },
};

const MypagePasswordEdit: React.FC = () => {
  const api = useApi();
  const scroll = useScroll({ scrollKey: 'index', smooth: true });
  const [password, setPassword] = useState('');
  const [passwordRepetition, setPasswordRepetition] = useState('');
  const [error, setError] = useState<{ [key: string]: string | null }>({});
  const [confirmStatus, setConfirmStatus] = useState(0);
  const [resultStatus, setResultStatus] = useState(0);

  const onChangePassword = async (value: string) => {
    setPassword(value);
    setError({ ...error, password: null });
  };

  const onChangePasswordRepetition = async (value: string) => {
    setPasswordRepetition(value);
    setError({ ...error, passwordRepetition: null });
  };

  const onConfirm = () => {
    const errors: [string, string][] = [];
    if (!password) {
      errors.push(['password', 'パスワードを入力してください']);
    }
    if (password !== passwordRepetition) {
      errors.push(['passwordRepetition', '入力内容に誤りがあります']);
    }
    if (
      password.length < 8 ||
      !password.match(/([0-9])/) ||
      !password.match(/([a-zA-Z])/)
    ) {
      errors.push(['password', 'パスワードの必須条件を満たしていません']);
    }
    if (errors.length) {
      errors.forEach(([key, message]) => {
        error[key] = message;
      });
      setError({ ...error });
      scroll(errors[0][0]);

      return;
    }

    setConfirmStatus(1);
  };

  const onSubmit = async () => {
    const result = await api.auth.changePassword(password);
    setConfirmStatus(0);
    setResultStatus(result ? 1 : 2);
  };

  const onUnderstoodResult = () => {
    setResultStatus(0);
  };

  return <Layout>
    <BackLink link='/' label='トップ'></BackLink>
    <H2>パスワード変更</H2>
    <div css={style.form}>
      <FormContent label='パスワード' required={true} requiredText='※8文字以上、半角数字・英数1文字以上を含む' anchorCode='password'>
        <ErrorMessage message={error.password} />
        <input type='password' value={password} onChange={(e) => onChangePassword(e.target.value)} />
      </FormContent>
      <FormContent label='パスワード（再入力）' required={true} anchorCode='passwordRepetition'>
        <ErrorMessage message={error.passwordRepetition} />
        <input type='password' value={passwordRepetition} onChange={(e) => onChangePasswordRepetition(e.target.value)} />
      </FormContent>
      <div css={generalStyle.formRow}>
        <button type='button' onClick={onConfirm} css={generalStyle.button()}>変更</button>
      </div>
    </div>
    <Modal display={!!confirmStatus} onHide={() => setConfirmStatus(0)}>
      <div>パスワードを変更します</div>
      <div css={modalStyle.buttonArea}>
        <button onClick={onSubmit} css={generalStyle.button()}>変更</button>
        <button onClick={() => setConfirmStatus(0)} css={generalStyle.button('warning')}>キャンセル</button>
      </div>
    </Modal>
    <Modal display={!!resultStatus} onHide={() => setResultStatus(0)}>
      <div>
        {resultStatus === 1 ? 'パスワードを変更しました' : 'パスワードの変更に失敗しました'}
      </div>
      <div css={modalStyle.buttonArea}>
        <button onClick={onUnderstoodResult} css={generalStyle.button()}>OK</button>
      </div>
    </Modal>
  </Layout>;
};

export default MypagePasswordEdit;
